var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarSep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0993 0.466553C24.0993 0.466553 22.4524 19.96 19.7351 21.3523C17.0177 22.7447 0.466675 25.12 0.466675 25.12C0.466675 25.12 20.8055 25.939 21.5466 29.0514C22.3701 32.2457 24.4287 47.2343 24.4287 47.2343C24.4287 47.2343 26.7343 27.3314 29.6987 26.5943C34.1452 25.6114 46.7438 23.0723 46.7438 23.0723C46.7438 23.0723 29.0399 22.6628 27.5577 20.6971C25.6638 18.3219 24.0993 0.466553 24.0993 0.466553Z",
    fill: "#d4af38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarSep);
export default __webpack_public_path__ + "static/media/star_sep.2429f9fa0a816b55066365fb021233b4.svg";
export { ForwardRef as ReactComponent };